// component/GroupModal.jsx
import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  message,
  Button,
  Flex,
  Typography,
} from "antd";
import http from "@/utils/http";
import api from "@/utils/api";
import { EditOutlined } from "@ant-design/icons";

const GroupModal = ({ 
  visible, 
  onClose, 
  onSuccess, 
  ownerOptions = [],
  editData = null,
  mode = 'create'
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (visible && mode === 'edit' && editData) {
      form.setFieldsValue({
        groupName: editData.groupName || '',
        ownerIds: editData.ownerIds || []
      });
    } else if (visible && mode === 'create') {
      form.resetFields();
    }
  }, [visible, mode, editData, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      
      setLoading(true);
      
      let res;
      if (mode === 'edit') {
        // 编辑模式
        res = await http.post(api.getUpdateBalanGroupList, {
          id: editData.id,
          groupName: values.groupName.trim(),
          ownerIds: values.ownerIds,
        });
      } else {
        // 创建模式
        res = await http.post(api.getAddGroupList, {
          groupName: values.groupName.trim(),
          ownerIds: values.ownerIds,
        });
      }

      if (res?.code !== "1") {
        message.error(res?.msg || (mode === 'edit' ? "Update group failed" : "Create group failed"));
        return;
      }

      message.success(mode === 'edit' ? "Group updated successfully" : "Group created successfully");
      form.resetFields();
      onSuccess?.();
      onClose();
    } catch (error) {
      console.log('Validation failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const handleSelectChange = (values) => {
    if (values.includes("all")) {
      form.setFieldsValue({ ownerIds: ["all"] });
    } else {
      const filteredValues = values.filter(v => v !== "all");
      form.setFieldsValue({ ownerIds: filteredValues });
    }
  };

  const selectOptions = [
    // { label: "All Owners", value: "all" },
    ...(ownerOptions || []).map((o) => ({
      label: o.name,
      value: o.ownerId,
    })),
  ];

  const modalTitle = mode === 'edit' ? 'Edit Group' : 'Create New Group';
  const submitButtonText = mode === 'edit' ? 'Update' : 'Save';

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            {modalTitle}
          </Typography.Title>
        </Flex>
      }
      width="30%"
      open={visible}
      centered
      maskClosable={false}
      onCancel={handleCancel}
       styles={{
      body: {
      height: '360px',
      maxHeight: '500px',
      overflow: 'auto',
      paddingBottom: '20px'
    }
  }}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            key="save"
            type="primary"
            loading={loading}
            onClick={handleSubmit}
          >
            {submitButtonText}
          </Button>
        </div>
      }
      destroyOnClose
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div>
            <Form
              form={form}
              layout="vertical"
              initialValues={{ groupName: "", ownerIds: [] }}
            >
              <Form.Item
                label="Group Name"
                name="groupName"
                rules={[
                  { required: true, message: "Please enter group name" },
                  { whitespace: true, message: "Group name cannot be empty" }
                ]}
              >
                <Input placeholder="Enter group name" />
              </Form.Item>
              <Form.Item
                label="Select Owner"
                name="ownerIds"
                rules={[
                  { 
                    required: true, 
                    message: "Please select at least one owner",
                    type: 'array',
                    validator: (_, value) => {
                      if (!value || value.length === 0) {
                        return Promise.reject(new Error('Please select at least one owner'));
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select owners"
                  onChange={handleSelectChange}
                  style={{ width: "100%" }}
                  optionFilterProp="label"
                  options={selectOptions}
                  dropdownStyle={{ maxHeight: '300px' }}
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default GroupModal;